import React from 'react';
import { Box, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';

interface Props {
  withGap?: boolean;
}

export const EmployerTerminationInfoBanner: React.FC<Props> = ({ withGap }) => {
  return (
    <Box
      background="canvas"
      border={{ color: 'border2', size: 'xsmall' }}
      align="center"
      round="container1Round"
      pad="spacing12"
      style={{ position: 'relative' }}
      margin={{ top: withGap ? 'spacing24' : undefined }}
      data-testid="EmployerTerminationInfoBanner-container"
    >
      <Box
        round="smallRound"
        height="2px"
        background="info"
        width="calc(100% - 24px)"
        style={{ top: '-1px', position: 'absolute' }}
      />
      <Box
        border={{ color: 'infoBorder', size: 'small' }}
        round="container2Round"
        align="center"
        background="infoContainer"
        pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
        width="100%"
      >
        <Box direction="row" align="center">
          <Box
            margin={{ right: 'spacing8' }}
            width={{ min: '24px' }}
            data-testid="EmployerTerminationInfoBanner-icon"
          >
            <InfoOutlineIcon color="info" />
          </Box>
          <Inscription
            color="textBody"
            lineHeight="20px"
            data-testid="EmployerTerminationInfoBanner-description"
          >
            All bank account details will be permanently removed 60 days after the organization is terminated.
          </Inscription>
        </Box>
      </Box>
    </Box>
  );
};
